import { BiChevronDown, BiChevronUp } from 'react-icons/bi';
import style from './style.module.scss';

export interface MessageBoxProps extends React.HTMLAttributes<HTMLDivElement> {
	upAction: () => void;
	downAction: () => void;
}

export default function ScrollBar({ upAction, downAction, ...props }: MessageBoxProps) {
	return (
		<div {...props} className={style['scroll-bar']}>
			<button type='button' onClick={() => upAction()}>
				<BiChevronUp size={'10rem'} />
			</button>
			<button type='button' onClick={() => downAction()}>
				<BiChevronDown size={'10rem'} />
			</button>
		</div>
	);
}
